module.exports = __webpack_public_path__ + "img/bg4.84a722fa.jpg";